import { posthog, isAnalyticsEnabled } from './analytics';

declare global {
  interface Window {
    fbq?: (action: string, eventName: string, params?: Record<string, unknown>) => void;
  }
}

export const APP_STORE_URL = 'https://apps.apple.com/us/app/dink-social/id6756313023';
export const ANDROID_PACKAGE = 'com.dinksocial.app';
export const PLAY_STORE_BASE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
export type UtmKey = typeof UTM_KEYS[number];
export type UtmParams = Record<UtmKey, string | null>;

export const EMPTY_UTMS: UtmParams = UTM_KEYS.reduce((acc, key) => {
  acc[key] = null;
  return acc;
}, {} as UtmParams);

export function readUtmParams(search: string): UtmParams {
  const params = new URLSearchParams(search);
  return UTM_KEYS.reduce((acc, key) => {
    acc[key] = params.get(key);
    return acc;
  }, {} as UtmParams);
}

export function buildPlayStoreUrl(utms: UtmParams): string {
  const utmString = UTM_KEYS
    .filter((key) => utms[key])
    .map((key) => `${key}=${encodeURIComponent(utms[key] as string)}`)
    .join('&');
  return utmString ? `${PLAY_STORE_BASE_URL}&referrer=${encodeURIComponent(utmString)}` : PLAY_STORE_BASE_URL;
}

export type StoreClickEvent = 'app_store_click' | 'play_store_click';
export type DeviceType = 'ios' | 'android';

export function captureStoreClick(
  eventName: StoreClickEvent,
  deviceType: DeviceType,
  utms: UtmParams
): void {
  if (typeof window === 'undefined') return;

  if (isAnalyticsEnabled()) {
    posthog.capture(
      eventName,
      {
        ...utms,
        referrer: typeof document !== 'undefined' ? document.referrer : '',
        device_type: deviceType,
      },
      { send_instantly: true }
    );
  }

  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: deviceType,
      content_category: 'app_store_click',
    });
  }
}
